
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 5100","d":"M25.99 7.962a6.229 6.229 0 0 1-.577 5.028.446.446 0 0 1-.65.214.6.6 0 0 1-.185-.752 5.085 5.085 0 0 0 .544-4.024 3.67 3.67 0 0 0-1.973-1.907v9.505a2.7 2.7 0 0 1-2.219 2.618c-1.444.4-2.8-.181-3.028-1.289s.76-2.328 2.2-2.724a2.943 2.943 0 0 1 2.087.145V5.77a.59.59 0 0 1 .176-.428.434.434 0 0 1 .4-.112 4.9 4.9 0 0 1 3.223 2.732zm-11.085 2.793a2.749 2.749 0 0 1-2.235 2.516c-1.444.4-2.8-.181-3.028-1.289s.76-2.328 2.2-2.724a2.94 2.94 0 0 1 2.1.151v-5.2L5.293 5.9v6.737a2.749 2.749 0 0 1-2.233 2.516c-1.444.4-2.8-.181-3.028-1.289s.76-2.328 2.2-2.724a2.94 2.94 0 0 1 2.1.151V2.433a.533.533 0 0 1 .4-.544L14.344.008a.431.431 0 0 1 .389.123.59.59 0 0 1 .17.423v10.2zm-.957-7.67V1.206L5.293 2.9v1.879zm27.5 10.313a2.94 2.94 0 0 1-2.1-.151v8.858a.533.533 0 0 1-.4.544l-9.612 1.881a.486.486 0 0 1-.08.009.441.441 0 0 1-.308-.13.586.586 0 0 1-.17-.423V13.781a2.749 2.749 0 0 1 2.233-2.516c1.444-.4 2.8.181 3.028 1.289s-.76 2.328-2.2 2.724a2.94 2.94 0 0 1-2.1-.151v5.2l8.656-1.693v-6.735a2.753 2.753 0 0 1 2.233-2.518c1.444-.4 2.8.181 3.028 1.289s-.758 2.33-2.2 2.726zm-3.057 6.362-8.656 1.693v1.879l8.656-1.693z"}})])
          )
        }
      }
    